import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';
import {FormAction} from "@shared/module/forms/model";

@Component({
  selector: 'app-error-dialog',
  templateUrl: './error-dialog.component.html',
  styleUrls: ['./error-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ErrorDialogComponent {
  @Input() message!: string;
  @Output() onOk = new EventEmitter<void>();
  protected readonly FormAction = FormAction;
}
